export const STORAGE_KEYS = {
    ACCESS_TOKEN: "accessToken",
    EXPIRATION: "expiration"
};
